// extracted by mini-css-extract-plugin
export default {"background":"footer_background__lClOR","control":"footer_control__igSKk","left":"footer_left__ixwFL"};